import BaseComponent from '../base-component/base-component'
import ProductCard from './product-card'
import { Nullable } from '../../types/common'

class ProductMediaTabs extends BaseComponent {
  productCard: Nullable<ProductCard>
  tabs: HTMLElement[]
  selected: Nullable<{ img: any; tab: any }>
  mainImage: Nullable<HTMLElement>

  constructor() {
    super()

    this.productCard = this.closest<ProductCard>('product-card')
    this.mainImage = this.productCard.querySelector('[data-main-media]')

    this.tabs = [
      ...this.querySelectorAll('[data-product-media-tabs-item]'),
    ] as HTMLElement[]

    this.selected = null
  }

  connectedCallback(): void {
    this.tabs.forEach(tab => {
      tab.addEventListener('mouseenter', this.handleTabEnter)
      tab.addEventListener('mouseleave', this.handleTabLeave)
    })
  }

  disconnectedCallback(): void {
    this.tabs.forEach(tab => {
      tab.removeEventListener('mouseenter', this.handleTabEnter)
      tab.removeEventListener('mouseleave', this.handleTabLeave)
    })
  }

  handleTabEnter = (event): void => {
    const tab = event.currentTarget
    const img = this.productCard.querySelector<HTMLElement>(
      `[data-id="${tab.dataset.id}"]`,
    )

    if (this.selected) {
      this.reset()
    }

    this.setTabSelect(tab, true)
    this.setImageVisible(img, true)
    this.setImageVisible(this.mainImage, false)

    this.selected = { tab, img }
  }

  handleTabLeave = (): void => {
    if (this.selected) {
      this.reset()
    }

    this.setImageVisible(this.mainImage, true)
  }

  setTabSelect(tab: HTMLElement, isSelected: boolean): void {
    tab.classList.toggle('selected', isSelected)
  }

  setImageVisible(img: HTMLElement, isVisible: boolean): void {
    img.classList.toggle('product-card__img--visible', isVisible)
  }

  reset(): void {
    if (!this.selected) {
      return
    }

    this.selected.img.classList.remove('product-card__img--visible')
    this.selected.tab.classList.remove('selected')
    this.selected = null
  }
}

export default ProductMediaTabs
